module.exports = __webpack_public_path__ + "static/media/konno-yuuki-win.76599ebe.png";